import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let EmptyTemplateComp;

class Empty_template extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: EmptyTemplateComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/empty-template-comp" */
      "../../../components/javascript/zcat-components/empty-template-comp"
    ).then(function(res) {
      EmptyTemplateComp = res.EmptyTemplateComp;
    }));

    
;
  }
}

export { Empty_template };
